import { render, staticRenderFns } from "./rob-portfolio.vue?vue&type=template&id=10d83e73&scoped=true"
import script from "./rob-portfolio.vue?vue&type=script&lang=js"
export * from "./rob-portfolio.vue?vue&type=script&lang=js"
import style0 from "./rob-portfolio.vue?vue&type=style&index=0&id=10d83e73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d83e73",
  null
  
)

export default component.exports